module.exports = __webpack_public_path__ + "img/mascara_anti.28c6714d.png";